export interface BulkTransferBase {
    data: BulkTransfer[];
    status_code?: number;
}

export interface BulkTransfer {
    amount?: number;
    from_trading_account?: string;
    to_trading_account?: string;
    error_message?: string;
    type?: string;
    from_ticket?: string;
    to_ticket?: string;
}
